import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Radio,
  Select,
} from "antd";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";

const AddModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const [showParent, setShowParent] = useState(false);
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [parentList, setParentList] = useState([]);
   const [moduleList, setModuleList] = useState([]);
  // 单选：Yes=1, No=0
  const signOptions = [
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];

  // const loadParentList = async () => {
  //   try {
  //     const response = await http.get(api.getGlTransRulesList);
  //     const data = (response.data || []).map((item) => ({
  //       value: item.id,
  //       label: item.name,
  //     }));
  //     setParentList(data);
  //   } catch (err) {
  //     console.error("Failed :", err);
  //   }
  // };
const loadParentList = async () => {
  try {
    const response = await http.get(api.getGlTransRulesList);

    const getLevel1List = (list = []) => {
      const result = [];

      list.forEach((item) => {
        // 只取 level === 1 的数据
        if (item.level === 1) {
          result.push({
            value: item.id,
            label: item.name,
          });
        }

        // 继续递归 children
        if (item.children?.length) {
          result.push(...getLevel1List(item.children));
        }
      });

      return result;
    };

    const data = getLevel1List(response.data || []);

    setParentList(data);
  } catch (err) {
    console.error("Failed :", err);
  }
};
    const loadModuleList = async () => {
    try {
      const response = await http.get(api.getGLByModuleList);
      const data = (response.data.data || []).map((item) => ({
        value: item.moduleValue,
        label: item.module,
      }));
      setModuleList(data);
    } catch (err) {
      console.error("Failed :", err);
    }
  };


  useImperativeHandle(ref, () => ({
    setModelAdd: async (parentId = null) => {
      form.resetFields();
      form.setFieldsValue();
      setVisible(true);
      await Promise.all([loadParentList()]);
       await Promise.all([loadModuleList()]);
    },
  }));

  const onFinish = async (values) => {
    setLoading(true);

    try {
      const queryParams = {
        name: values.name,
        code: values.code || "",
        parentId: values.parentId ?? null,
        rules: values.rules || "",
        sign: values.sign ?? 0,
        module:values.module
      };

      const response = await http.post(api.getGlTransRulesAdd, queryParams);

      if (response?.code === "1") {
        message.success("Gl Trans Rules Add Successfully");

        setVisible(false);
        form.resetFields();
        onSuccess && onSuccess();
      } else {
        message.error(response?.msg);
      }
    } catch (err) {
      console.error(err);
      message.error("Request failed, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            ADD GL TRANS RULES
          </Typography.Title>
        </Flex>
      }
      width="60%"
      open={visible}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
      }}
      maskClosable={false}
      footer={
         <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button
          key="back"
          onClick={() => {
            setVisible(false);
            form.resetFields();
          }}
        >
          Cancel
        </Button>
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>
      </div>}
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div className="model_content">
            <Form
              form={form}
              name="createBankForm"
              layout="horizontal"
              labelCol={{ style: { width: "200px" } }}
              wrapperCol={{ style: { flex: 1 } }}
              onFinish={onFinish}
            >
              <Flex justify="space-between" align="flex-start">
                <div style={{ flex: 1 }}>
                  <Form.Item
                    name="name"
                    label="Name"
                    rules={[
                      {
                        required: true,
                        message: "Please enter a  name",
                      },
                      {
                        type: "name",
                        message: "Please enter a name",
                      },
                    ]}
                  >
                    <Input placeholder="Please enter a name ." allowClear />
                  </Form.Item>

                  <Form.Item
                    name="code"
                    label="Code"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Please enter a code." allowClear />
                  </Form.Item>
                  <Form.Item
                    name="sign"
                    label="Is Expense"
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder="Select Is Expense"
                      options={signOptions}
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
    
                 <Form.Item
                    name="module"
                    label="Module"
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder="Select Module"
                      options={moduleList}
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>

                  <Form.Item
                    name="level"
                    label="Level"
                    rules={[{ required: true }]}
                  >
                    <Radio.Group
                      onChange={(e) =>
                        setShowParent(e.target.value === "level2")
                      }
                    >
                      <Radio value="level1">Level 1</Radio>
                      <Radio value="level2">Level 2</Radio>
                    </Radio.Group>
                  </Form.Item>

                  {showParent && (
                    <Form.Item
                      name="parentId"
                      label="Type"
                      rules={[
                        { required: true, message: "Please select  type" },
                      ]}
                    >
                      <Select
                        placeholder="Select  type"
                        options={parentList}
                        allowClear
                        showSearch
                        optionFilterProp="label"
                      />
                    </Form.Item>
                  )}

                  {showParent && (
                    <Form.Item name="rules" label="Rules">
                      <TextArea />
                    </Form.Item>
                  )}
                </div>
              </Flex>
            </Form>
          </div>
        </div>
      </Flex>
    </Modal>
  );
});

export default AddModal;
